import { Button, Flex, Heading, Text } from '@grammarly/design-system'

import { ToneChatIcon } from '../icons/ToneChatIcon'

import classes from './UserFeedback.module.scss'

type Props = {
  readonly onClose: () => void
}

export function UserFeedbackComplete({ onClose }: Props) {
  return (
    <Flex
      align="center"
      justify="center"
      direction="column"
      gap={6}
      className={classes.userFeedback}
    >
      <ToneChatIcon accessibilityLabel="" />
      <Flex direction="column" align="center">
        <Heading as="h2" className={classes.userFeedbackCompleteHeader} variant="heading-small">
          Your feedback makes us better
        </Heading>
        <Text as="p" color="base-subdued">
          Thank you for sharing your thoughts.
        </Text>
      </Flex>
      <Button text="Close" onClick={onClose} size="large" />
    </Flex>
  )
}
